import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {MatMenuModule} from '@angular/material/menu';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { LanguageComponent } from './components/language/language.component';
import { TitleCaseCustomPipe } from './pipes/title-case-custom.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
const exportComponents: any = [
  HeaderComponent,
  FooterComponent,
  LanguageComponent,
];

const exportDirectives = [
];

const exportPipes = [
  TitleCaseCustomPipe,
];

const exportModules = [
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  MatMenuModule,
  TranslateModule, 
  MatSelectModule,
  MatFormFieldModule
];
@NgModule({
  declarations: [
    ...exportComponents,
    ...exportDirectives,
    ...exportPipes
  ],
  imports: [
    ...exportModules,
    CarouselModule.forRoot(),
  ],
  exports: [
    ...exportComponents,
    ...exportDirectives,
    ...exportModules,
    ...exportPipes,
    CarouselModule,
    PopoverModule
  ]
})
export class SharedModule { }
